import React from 'react';

type Props = {
  children: React.ReactNode;
};

export default function Bootstrap(props: Props) {
  return <>{props.children}</>;
}
